import PropTypes from 'prop-types'
import { RdtRegulationTypes } from '../../models/rdt/rdt-regulation-types-enum'
import { RdtRuleTypes } from '../../models/rdt/rdt-rule-types-enum'

/**
 * @typedef {Object} DriverRdtRuleRegulationOption
 * @property {string} [stringCode]  - Translation string code for regulation option type.
 * @property {string} [type]        - Regulation option type.
 * @property {string} [value]       - Regulation option value.
 */
const driverRdtRuleRegulationOptionPropType = PropTypes.shape({
    stringCode: PropTypes.string,
    type: PropTypes.oneOf(Object.values(RdtRuleTypes)),
    value: PropTypes.string
})

/**
 * @typedef {Object} DriverRdtRuleRegulation
 * @property {DriverRdtRuleRegulationOption[]} [options]    - Regulation options.
 * @property {string} [type]                                - Regulation type.
 */
const driverRdtRuleRegulationPropType = PropTypes.shape({
    options: PropTypes.arrayOf(driverRdtRuleRegulationOptionPropType),
    type: PropTypes.oneOf(Object.values(RdtRegulationTypes))
})

/**
 * @typedef {Object} DriverRdtRule
 * @property {string} [country]                       - Country ISO code (2-characters, uppercase).
 * @property {string} [driverId]                      - Driver identification.
 * @property {boolean} [isDefault]                    - Flag to indicate a default driver configuration (no custom).
 * @property {DriverRdtRuleRegulation} [regulation]   - RDT regulation used for calculating driving/working times.
 */
export const driverRdtRulePropType = PropTypes.shape({
    country: PropTypes.string,
    driverId: PropTypes.string,
    isDefault: PropTypes.bool,
    regulation: driverRdtRuleRegulationPropType
})
